Ext.define('SA.AcsTable.ModelFactory', {
    singleton: true,

    createModel({project, data, locationItems}) {
        var censusReleaseYear = data.buildingBlocksCensusRelease;

        data.edition = SA.data.Vendors.getACSModel().getLatestEditionForCensusReleaseYear(censusReleaseYear);
        data.tableId = SA.AcsTable.Model.getDefaultTableId();

        return this.instantiateModel({project, data: {...data, locationItems}});
    },

    instantiateModel({id, project, data, saved}) {
        var model = new SA.AcsTable.Model({id, project, data, saved}),
            locationsObserver = new SA.model.LocationsObserverFactory().createObserver({project, view: model}),
            requestedAttributeIds = new SA.AcsTable.RequestedAttributeIds();

        model.resolveState();

        model.on('remove', () => locationsObserver.clearListeners());
        model.on('change:name', () => model.resolveState());

        locationsObserver.on('change:location', () => model.resolveState());

        model.requestedAttributeIds = requestedAttributeIds;
        model.createController = () => SA.AcsTable.ViewController.createController({model, requestedAttributeIds});

        return model;
    }
});